import { codegenApi } from '@/api';

const commonAPI = codegenApi.enhanceEndpoints({
  endpoints: {
    customerGetAll: {},
    customerGet: {
      providesTags: ['Customers'],
    },
    customerCreate: {
      invalidatesTags: ['Customers'],
    },
    customerGetAllCustomersBySessionIds: {
      providesTags: ['Customers'],
    },
    customerGetCustomersEnrolmentBySessionId: {
      providesTags: ['CustomerEnrolments'],
    },
    enrolmentEnrol: {
      invalidatesTags: ['CustomerEnrolments'],
    },
    enrolmentGetEnrolmentSessionByCustomerId: {
      providesTags: ['CustomerEnrolments'],
    },
    enrolmentUnEnrol: {
      invalidatesTags: ['CustomerEnrolments'],
    },
    enrolmentUpdateEnrollmentData: {
      invalidatesTags: ['CustomerEnrolments'],
    },
    resultGetById: {
      providesTags: ['Customers'],
    },
    sessionGetActive: {
      providesTags: ['Sessions'],
    },
    sessionGetAll: {},
    sessionGet: {
      providesTags: ['Sessions'],
    },
    enrolmentResit: {
      invalidatesTags: ['Customers'],
    },
    customerUploadCustomer: {
      invalidatesTags: ['Customers'],
    },
    customerUploadAndEnroll: {
      invalidatesTags: ['Customers'],
    },
    enrolmentCreateEor: {
      invalidatesTags: ['Customers'],
    },
    resultDownloadBulkResults: {
      extraOptions: {
        downloadFile: true,
      },
    },
    resultDownloadCertificate: {
      extraOptions: {
        downloadFile: true,
      },
    },
    permissionsGetPermissionsByOrgId: {
      providesTags: ['OrganisationPermissions'],
    },
    attendanceDownloadAttendance: {
      extraOptions: {
        downloadFile: true,
      },
    },
    resultDownloadBulkCertificates: {
      extraOptions: {
        downloadFile: true,
      },
    },
    resultSendCertificatesByEmail: {},
  },
});

export { commonAPI };
